export const stuffedAnimalsList = [

				
]